export type CurrencyCode =
  | 'AUD'
  | 'BGN'
  | 'BRL'
  | 'CAD'
  | 'CHF'
  | 'CNY'
  | 'DKK'
  | 'EUR'
  | 'GBP'
  | 'HKD'
  | 'HUF'
  | 'IDR'
  | 'ILS'
  | 'JPY'
  | 'KRW'
  | 'MXN'
  | 'MYR'
  | 'NOK'
  | 'NZD'
  | 'PHP'
  | 'PLN'
  | 'RON'
  | 'SEK'
  | 'SGD'
  | 'THB'
  | 'TRY'
  | 'USD'
  | 'ZAR'

export interface Money {
  amount: number
  currencyCode?: CurrencyCode
  formattedAmount?: string
}

export type SupportedCurrencyCode = 'AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD'

export function format<T>(
  price?: T,
  currency = 'USD',
  defaultVal = '$0.00',
  locale = 'en-US',
): string {
  if (typeof price !== 'number') {
    return defaultVal
  }
  return `${new Intl.NumberFormat(locale, { style: 'currency', currency }).format(
    price / 100,
  )} ${currency}`
}

export function formatWithoutCurrencySymbol(
  price?: number,
  currencyCode?: string,
  displayZero = false,
): string {
  if (!price) {
    return displayZero ? `0.00 ${currencyCode}` : 'N/A'
  }
  const formattedPrice = format(price)
    .replace(/[^0-9.,]/g, '')
    .concat(' ', currencyCode || '')
    .trim()

  return formattedPrice
}

type Locale = 'en-US' | 'fr-CA' | 'en-CA'
const LOCALE_CURRENCY: Record<Locale, CurrencyCode> = {
  'en-US': 'USD',
  'fr-CA': 'CAD',
  'en-CA': 'CAD',
}

export function getCurrencyCodeByLocale(locale: Locale): CurrencyCode {
  return LOCALE_CURRENCY[locale] || 'USD'
}
